export const pricingMetaData = {
	name: 'robots',
	content: 'noindex, follow',
};
